// STUB — FTMS Step Climber Data characteristic (0x2ACF). Spec §4.11.
//
// Phase 2: 16-bit flags. Bit 0 inverted (More Data). Field order: Step Per
// Minute (uint16) + Step Count (uint16) when bit 0 clear, then Avg Step Rate,
// Positive Elevation Gain, Energy, HR, MET, Elapsed Time, Remaining Time.

import type { StepClimberMetrics } from "../types";

export function parseStepClimberData(_view: DataView): StepClimberMetrics {
  return {
    type: "step_climber",
    power_watts: null,
    heart_rate_bpm: null,
    elapsed_time_s: null,
    remaining_time_s: null,
    step_rate_spm: null,
    step_count: null,
  };
}
